
import { Crown, Bookmark, BookOpen, MessageCircle, Church, Heart } from "lucide-react";
import { Card } from "@/components/ui/card";
import { useTheme } from "@/components/ui/theme-provider";

export function PremiumFeatures() {
  const { theme } = useTheme();

  const getCardClasses = () => {
    if (theme === 'dark') {
      return "p-6 bg-app-surface/80 backdrop-blur-sm border border-app-border transition-colors duration-300";
    }
    return "p-6 bg-white/90 backdrop-blur-sm border border-blue-100 transition-colors duration-300";
  };

  const getIconBgClasses = () => {
    if (theme === 'dark') {
      return "p-2 bg-app-accent/20 rounded-lg";
    }
    return "p-2 bg-grace-light rounded-lg";
  };

  const getIconColor = () => {
    return theme === 'dark' ? 'text-app-accent' : 'text-grace-dark';
  };

  const getTitleColor = () => {
    return theme === 'dark' ? 'text-app-text-primary' : 'text-grace-dark';
  };

  const getDescriptionColor = () => {
    return theme === 'dark' ? 'text-app-text-secondary' : 'text-muted-foreground';
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 animate-fade-in">
      <Card className={getCardClasses()}>
        <div className="flex items-start gap-4">
          <div className={getIconBgClasses()}>
            <BookOpen className={`w-6 h-6 ${getIconColor()} transition-colors duration-300`} />
          </div>
          <div>
            <h3 className={`font-semibold text-lg ${getTitleColor()} transition-colors duration-300`}>Daily Devotionals</h3>
            <p className={`text-sm ${getDescriptionColor()} transition-colors duration-300`}>
              Interactive daily devotionals with reflection questions and prayer prompts
            </p>
          </div>
        </div>
      </Card>

      <Card className={getCardClasses()}>
        <div className="flex items-start gap-4">
          <div className={getIconBgClasses()}>
            <Heart className={`w-6 h-6 ${getIconColor()} transition-colors duration-300`} />
          </div>
          <div>
            <h3 className={`font-semibold text-lg ${getTitleColor()} transition-colors duration-300`}>Prayer Requests</h3>
            <p className={`text-sm ${getDescriptionColor()} transition-colors duration-300`}>
              Share prayer requests with your community and pray for others
            </p>
          </div>
        </div>
      </Card>

      <Card className={getCardClasses()}>
        <div className="flex items-start gap-4">
          <div className={getIconBgClasses()}>
            <Bookmark className={`w-6 h-6 ${getIconColor()} transition-colors duration-300`} />
          </div>
          <div>
            <h3 className={`font-semibold text-lg ${getTitleColor()} transition-colors duration-300`}>Journaling</h3>
            <p className={`text-sm ${getDescriptionColor()} transition-colors duration-300`}>
              Spiritual journaling with mood tracking and AI-generated reflections
            </p>
          </div>
        </div>
      </Card>

      <Card className={getCardClasses()}>
        <div className="flex items-start gap-4">
          <div className={getIconBgClasses()}>
            <BookOpen className={`w-6 h-6 ${getIconColor()} transition-colors duration-300`} />
          </div>
          <div>
            <h3 className={`font-semibold text-lg ${getTitleColor()} transition-colors duration-300`}>Scripture Journeys</h3>
            <p className={`text-sm ${getDescriptionColor()} transition-colors duration-300`}>
              Guided Bible verse journeys for peace, hope, strength, joy, courage, and gratitude
            </p>
          </div>
        </div>
      </Card>

      <Card className={getCardClasses()}>
        <div className="flex items-start gap-4">
          <div className={getIconBgClasses()}>
            <Crown className={`w-6 h-6 ${getIconColor()} transition-colors duration-300`} />
          </div>
          <div>
            <h3 className={`font-semibold text-lg ${getTitleColor()} transition-colors duration-300`}>NFC Bracelet Integration</h3>
            <p className={`text-sm ${getDescriptionColor()} transition-colors duration-300`}>
              Connect and manage your Grace Awakens NFC bracelets
            </p>
          </div>
        </div>
      </Card>

      <Card className={getCardClasses()}>
        <div className="flex items-start gap-4">
          <div className={getIconBgClasses()}>
            <Church className={`w-6 h-6 ${getIconColor()} transition-colors duration-300`} />
          </div>
          <div>
            <h3 className={`font-semibold text-lg ${getTitleColor()} transition-colors duration-300`}>Church Admin Tools</h3>
            <p className={`text-sm ${getDescriptionColor()} transition-colors duration-300`}>
              AI-powered sermon planning, congregation insights, and community management
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
}
